import { TextBox } from "devextreme-react"
import { generate } from "generate-password-browser";
import React, { useState } from "react"

function PasswordInput(props){

    const {value, setValue, label} = props;
    const [mode, setMode] = useState("password")

    function generatePassword(){
         const password = generate({
                length: 16,
                numbers: true,
                symbols: true,
                uppercase: true,
                lowercase: true
            })
        
        setValue({value:password})
        setMode("text");
        
    }

    return(
        <div style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
            <span style={{flexGrow: 1}} >
                <TextBox label={label} readOnly labelMode="floating" mode={mode} style={{height: "3rem"}} value={value}>
                </TextBox></span>
            <div className="refresh-password-button" onClick={generatePassword} role="button"><i className="icon icon-refresh"></i></div>
        </div>
    )
}

export {PasswordInput}